import { useEffect, useState } from 'react'
import {
  calculateFinancialInfo,
  FinancialInfo
} from '@/core/hooks/useFinancialInfo/utils.ts'
import { Dayjs } from 'dayjs'

const defaultFinancialInfo: FinancialInfo = {
  initial: 0,
  additional_cost: 0,
  initial_total: 0,
  payment_cuotes: 0,
  total_payment: 0,
  tasa: 0,
  rentability: 0,
  list_cuotes: [],
  payment_extra: 0,
  policyPercentage: null,
  policyValueToSum: null
}

interface Props {
  initialByLevel?: number
  initial?: number
  clientCreditValue: number
  offerDiscountPercent: number | null
  offerWithoutCreditLimit: boolean
  rentabilityTasa: number
  rentabilityCantCuotes: number
  rentabilityTimesCuotes: number
  cost: number
  payment_extra: number
  policyPercentage?: number | string | null
  maxCost?: number | string | null
  date: Dayjs
}

const useFinancialInfo = ({
  initialByLevel,
  initial,
  clientCreditValue,
  offerDiscountPercent,
  offerWithoutCreditLimit,
  rentabilityTasa,
  rentabilityCantCuotes,
  rentabilityTimesCuotes,
  cost,
  payment_extra,
  policyPercentage,
  maxCost,
  date
}: Props) => {
  const [financialInformation, setFinancialInformation] =
    useState(defaultFinancialInfo)

  useEffect(() => {
    if (!cost || !rentabilityCantCuotes || !date) {
      setFinancialInformation(defaultFinancialInfo)
      return
    }
    const f = calculateFinancialInfo({
      initialByLevel,
      initial,
      clientCreditValue,
      offerDiscountPercent,
      isOfferWithoutCreditLimit: offerWithoutCreditLimit,
      rentabilityTasa,
      rentabilityCantCuotes,
      rentabilityTimesCuotes,
      cost,
      payment_extra,
      date,
      policyPercentage,
      maxCost
    })
    setFinancialInformation(f)
  }, [
    initialByLevel,
    initial,
    clientCreditValue,
    cost,
    date,
    offerDiscountPercent,
    offerWithoutCreditLimit,
    payment_extra,
    rentabilityCantCuotes,
    rentabilityTasa,
    rentabilityTimesCuotes,
    policyPercentage,
    maxCost
  ])

  return {
    financialInformation
  }
}

export default useFinancialInfo
